module.exports = __webpack_public_path__ + "static/media/robot-orange.05249125.svg";